import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { FloatingIconButton } from '@/components';
import { updateInspectMode } from '@/features/analysisMapSlice';
import { GeoLocator } from '@/views/map/GeoLocator';
import { Crosshair } from 'react-feather';
import { LayerManager } from '@/views/map/LayerManager';

import classes from './ActionBar.module.css';
import { useTouch } from '@/hooks/useTouch';
import { GroupAnalysisType } from '@/generated/types/navigator/types.gen';

interface ActionBarProps {
  openLayerManager: boolean;
  setOpenLayerManager: React.Dispatch<React.SetStateAction<boolean>>;
  style?: React.CSSProperties;
}

export function ActionBar({
  openLayerManager,
  setOpenLayerManager,
  style,
}: ActionBarProps) {
  const { selectedAnalysis } = useAppSelector((s) => s.analysisMap);
  const dispatch = useAppDispatch();
  const isTouchDevice = useTouch();

  const hasFallInOptionSelected =
    selectedAnalysis === GroupAnalysisType.FALL_IN;

  return (
    <div className={classes.mapButtons} style={style}>
      <LayerManager
        openLayerManager={openLayerManager}
        setOpenLayerManager={setOpenLayerManager}
      />
      {isTouchDevice && !hasFallInOptionSelected && (
        <FloatingIconButton
          Component={Crosshair}
          onClick={() => dispatch(updateInspectMode(true))}
        />
      )}
      <GeoLocator />
    </div>
  );
}
